// Mock data for SynergyTuff India Website

export const companyInfo = {
  name: "SynergyTuff India Private Limited",
  tagline: "Strength. Clarity. Experience.",
  email: "synergytuff@gmail.com",
  phone: "+91-8003513338",
  address: "KEC Int 50-54,63-65,67, JHOTWARA INDUSTRIAL AREA, JAIPUR-302012, RAJASTHAN",
  experience: "50+ years",
  logo: "https://customer-assets.emergentagent.com/job_architectural-steel/artifacts/y7ae3786_Synergytuff%20logo.png"
};

export const heroImages = [
  "https://images.unsplash.com/photo-1654105727849-1b9d39357f16",
  "https://images.unsplash.com/photo-1677253200111-97d0d490d60e",
  "https://images.unsplash.com/photo-1690944926899-cc0a52be0730"
];

export const products = [
  {
    id: 1,
    name: "Toughened Glass",
    description: "Superior strength safety glass that's 4-5 times stronger than standard glass",
    technicalSpecs: [
      "Thickness Range: 4mm to 19mm",
      "Maximum Size: 3000mm x 8000mm",
      "Heat Treatment: 650°C tempering",
      "Impact Resistance: 5x standard glass",
      "Thermal Stability: -70°C to +300°C",
      "Standards: IS 2553, EN 12150, ASTM C1048"
    ],
    features: [
      "Enhanced safety - breaks into small granular chunks",
      "Higher resistance to thermal stress",
      "Scratch resistant surface",
      "Cannot be cut or drilled post-tempering",
      "Optical clarity maintained"
    ],
    image: "https://images.unsplash.com/photo-1654105727849-1b9d39357f16"
  },
  {
    id: 2,
    name: "Architectural Glass",
    description: "Premium aesthetic solutions for modern building facades and interiors",
    technicalSpecs: [
      "Types: Float, Low-E, Solar Control",
      "Thickness: 5mm to 25mm",
      "Coatings: UV-resistant, anti-reflective",
      "Tints: Clear, Grey, Bronze, Green, Blue",
      "U-Value: 1.1 to 5.8 W/m²K",
      "Standards: IS 14900, EN 1279, IGCC"
    ],
    features: [
      "Energy efficient glazing solutions",
      "Acoustic insulation up to 45dB",
      "UV protection - 99% filtering",
      "Custom tinting and finishes",
      "Weather resistant"
    ],
    image: "https://images.unsplash.com/photo-1677253200111-97d0d490d60e"
  },
  {
    id: 3,
    name: "Safety Glass",
    description: "Engineered protection for high-security and safety-critical applications",
    technicalSpecs: [
      "Types: Laminated, Bulletproof, Fire-rated",
      "Thickness: 6mm to 60mm (laminated)",
      "Interlayer: PVB, SGP, EVA",
      "Fire Rating: 30 to 120 minutes",
      "Bullet Resistance: BR1 to BR7",
      "Standards: IS 2553, EN 356, EN 1063"
    ],
    features: [
      "Post-breakage retention",
      "Security against forced entry",
      "Fire and smoke barrier",
      "Acoustic dampening",
      "UV and solar control options"
    ],
    image: "https://images.pexels.com/photos/17631857/pexels-photo-17631857.jpeg"
  },
  {
    id: 4,
    name: "Customized Glass Solutions",
    description: "Bespoke glass engineering for unique architectural visions",
    technicalSpecs: [
      "Processes: Cutting, Edging, Drilling, Tempering",
      "Finishes: Sandblasted, Acid-etched, Printed",
      "Shapes: Flat, Curved, Complex geometries",
      "Sizes: Custom to project requirements",
      "Integration: Smart glass, LED embedded",
      "Lead Time: 2-4 weeks based on complexity"
    ],
    features: [
      "CAD/CAM precision manufacturing",
      "Digital printing capabilities",
      "CNC cutting and shaping",
      "Custom edge profiles",
      "Prototype development support"
    ],
    image: "https://images.pexels.com/photos/35157091/pexels-photo-35157091.jpeg"
  }
];

export const applications = [
  {
    id: 1,
    name: "Building Facades",
    description: "Transform exteriors with stunning glass facades that blend aesthetics with performance",
    benefits: [
      "Natural light maximization",
      "Energy efficiency with solar control",
      "Weather resistance and durability",
      "Iconic architectural presence"
    ],
    image: "https://images.unsplash.com/photo-1690944926899-cc0a52be0730"
  },
  {
    id: 2,
    name: "Glass Railings",
    description: "Elegant safety barriers that maintain unobstructed views",
    benefits: [
      "Minimal visual obstruction",
      "High strength safety compliance",
      "Corrosion-resistant hardware",
      "Modern aesthetic appeal"
    ],
    image: "https://images.unsplash.com/photo-1764428950485-89462b447f90"
  },
  {
    id: 3,
    name: "Commercial Buildings",
    description: "Complete glass solutions for offices, retail, and hospitality spaces",
    benefits: [
      "Professional workspace environments",
      "Acoustic privacy solutions",
      "Brand identity integration",
      "Flexible space division"
    ],
    image: "https://images.unsplash.com/photo-1770048532712-4fde5ef7eb90"
  },
  {
    id: 4,
    name: "Residential Interiors",
    description: "Bring luxury and light into homes with premium glass installations",
    benefits: [
      "Space enhancement through transparency",
      "Privacy with style (frosted options)",
      "Easy maintenance surfaces",
      "Timeless design value"
    ],
    image: "https://images.unsplash.com/photo-1611066415956-91ab6f1f57cc"
  },
  {
    id: 5,
    name: "Showrooms & Retail",
    description: "Create inviting commercial spaces that showcase products beautifully",
    benefits: [
      "Visual merchandising enhancement",
      "Security without barriers",
      "Customer experience focus",
      "Durable high-traffic solutions"
    ],
    image: "https://images.unsplash.com/photo-1740999540807-7cb06da25824"
  },
  {
    id: 6,
    name: "Industrial Installations",
    description: "Heavy-duty glass solutions for demanding industrial environments",
    benefits: [
      "Chemical and heat resistance",
      "Safety compliance certified",
      "High-impact durability",
      "Long service life"
    ],
    image: "https://images.pexels.com/photos/17631857/pexels-photo-17631857.jpeg"
  }
];

export const galleryImages = [
  {
    id: 1,
    category: "Railings",
    image: "https://images.unsplash.com/photo-1762545444269-75ab7fc7cc0a",
    title: "Curved Glass Railing System"
  },
  {
    id: 2,
    category: "Railings",
    image: "https://images.unsplash.com/photo-1758862528822-b0094ae44705",
    title: "Frameless Glass Balustrade"
  },
  {
    id: 3,
    category: "Railings",
    image: "https://images.pexels.com/photos/34172036/pexels-photo-34172036.jpeg",
    title: "Architectural Railing Detail"
  },
  {
    id: 4,
    category: "Railings",
    image: "https://images.pexels.com/photos/10863287/pexels-photo-10863287.jpeg",
    title: "Modern Staircase Glass"
  },
  {
    id: 5,
    category: "Office Partitions",
    image: "https://images.unsplash.com/photo-1748764720733-3bb4c52ab6f9",
    title: "Executive Office Glass Walls"
  },
  {
    id: 6,
    category: "Office Partitions",
    image: "https://images.unsplash.com/photo-1770993151375-0dee97eda931",
    title: "Collaborative Workspace Dividers"
  },
  {
    id: 7,
    category: "Office Partitions",
    image: "https://images.unsplash.com/photo-1765371513492-264506c3ad09",
    title: "Modern Office Interior Glass"
  },
  {
    id: 8,
    category: "Office Partitions",
    image: "https://images.pexels.com/photos/34823912/pexels-photo-34823912.jpeg",
    title: "Conference Room Glass Partition"
  },
  {
    id: 9,
    category: "Doors",
    image: "https://images.unsplash.com/photo-1769394002578-3a3e359130bd",
    title: "Frameless Glass Entry Door"
  },
  {
    id: 10,
    category: "Doors",
    image: "https://images.pexels.com/photos/7446065/pexels-photo-7446065.jpeg",
    title: "Commercial Glass Door System"
  },
  {
    id: 11,
    category: "Doors",
    image: "https://images.pexels.com/photos/7112264/pexels-photo-7112264.jpeg",
    title: "Luxury Entrance Glass Door"
  },
  {
    id: 12,
    category: "Doors",
    image: "https://images.unsplash.com/photo-1715156153744-d5fd2f1f66eb",
    title: "Sliding Glass Door Detail"
  },
  {
    id: 13,
    category: "Shower Partitions",
    image: "https://images.unsplash.com/photo-1771929662486-f793e08f0f16",
    title: "Premium Shower Enclosure"
  },
  {
    id: 14,
    category: "Shower Partitions",
    image: "https://images.pexels.com/photos/16501255/pexels-photo-16501255.jpeg",
    title: "Luxury Bathroom Glass"
  },
  {
    id: 15,
    category: "Shower Partitions",
    image: "https://images.pexels.com/photos/5088876/pexels-photo-5088876.jpeg",
    title: "Frameless Shower Glass"
  },
  {
    id: 16,
    category: "Commercial Buildings",
    image: "https://images.pexels.com/photos/35157091/pexels-photo-35157091.jpeg",
    title: "Modern Office Tower Facade"
  }
];

export const qualityFeatures = [
  {
    id: 1,
    title: "Precision Tempering",
    description: "Advanced computer-controlled furnaces ensure uniform heat treatment at 650°C",
    metric: "±2°C Accuracy"
  },
  {
    id: 2,
    title: "Quality Assurance",
    description: "Multi-stage inspection including visual, dimensional, and stress analysis",
    metric: "100% Inspection"
  },
  {
    id: 3,
    title: "Manufacturing Capacity",
    description: "State-of-the-art facility with high-volume production capabilities",
    metric: "5000+ m²/day"
  },
  {
    id: 4,
    title: "Industry Certifications",
    description: "Compliance with international safety and quality standards",
    metric: "ISO Certified"
  }
];

export const aboutContent = {
  legacy: "Built on over 50 years of unparalleled expertise in glass manufacturing, SynergyTuff India Private Limited stands as a beacon of quality and innovation in the toughened glass industry. Our journey began in the early 1970s, evolving from traditional glass craftsmanship to cutting-edge architectural solutions.",
  excellence: "Located in the industrial hub of Jaipur, our state-of-the-art manufacturing facility combines time-tested techniques with modern automation. Every piece of glass that leaves our facility undergoes rigorous quality control, ensuring it meets the highest standards of strength, clarity, and safety.",
  innovation: "We continuously invest in research, technology, and skilled workforce development to deliver glass solutions that exceed industry benchmarks. Our commitment to innovation drives us to explore new applications, from standard architectural glass to specialized safety solutions.",
  values: [
    "Uncompromising Quality",
    "Engineering Excellence",
    "Customer-Centric Innovation",
    "Sustainable Manufacturing",
    "50+ Years of Trust"
  ]
};

export const managingDirector = {
  name: "Mr. Abhinav Tekriwal",
  title: "Managing Director",
  photo: "https://customer-assets.emergentagent.com/job_architectural-steel/artifacts/akyk8qrz_WhatsApp%20Image%202026-02-25%20at%201.30.03%20PM.jpeg",
  headline: "Leadership That Blends Engineering Precision with Architectural Vision",
  bio: "Carrying forward a proud three-generation legacy in architectural glass, Mr. Abhinav Tekriwal brings together strong technical expertise and modern business leadership. With a background in Engineering and an MBA, he represents a new generation of industry leaders who understand both the science behind glass processing and the evolving demands of contemporary architecture.\n\nUnder his leadership, SynergyTuff India Private Limited focuses on delivering high-performance toughened glass solutions that meet global standards of safety, precision, and design. His deep understanding of tempering technology, structural applications, and architectural trends enables the company to bridge the gap between heavy industrial manufacturing and luxury architectural aesthetics. Known for his detail-oriented approach, Mr. Tekriwal actively drives innovation in production processes, quality control, and client-centric customization.\n\nWith a vision rooted in knowledge and experience, he continues to expand the company's capabilities while preserving the craftsmanship and trust built over decades. His leadership reflects a balance of technical depth, strategic thinking, and a passion for pushing architectural glass toward stronger, smarter, and more refined applications.",
  quote: "Glass is not just a material — it is a fusion of strength, precision, and design. Our goal is to engineer solutions that elevate architecture while ensuring uncompromised safety."
};

export const mockInquiries = [
  {
    id: "1",
    name: "Sample Inquiry",
    email: "test@example.com",
    phone: "+91-9999999999",
    company: "Test Company",
    message: "Looking for glass facade solutions",
    productInterest: "Architectural Glass",
    createdAt: new Date().toISOString()
  }
];
